export const locale = {
    lang: 'de',
    data: {
        DELETEDIALOG: {
            CONFIRM: 'Bestätigung',
            OK: 'OK',
            CANCEL: 'Abbrechen',
        },
    },
};
